const option = {
  method: 'POST',
  //mode:'same-origin',
}
export const fetcher = url => fetch(url,option).then(r => r.json())
